/**
 * Utility for managing recently viewed products in sessionStorage.
 * Always stores product handles, never IDs.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in sessionStorage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 12;

  /**
   * Adds a product handle to the recently viewed list.
   * @param {string} productHandle - The handle of the product to add.
   */
  static addProduct(productHandle) {
    if (!productHandle || typeof productHandle !== 'string') return;

    // Ensure we're storing handles only (no pure numeric IDs)
    if (/^\d+$/.test(productHandle)) return;

    let viewed = this.getProducts();

    // Keep unique, most recent first
    viewed = viewed.filter(h => h !== productHandle);
    viewed.unshift(productHandle);

    // Limit list size
    viewed = viewed.slice(0, this.#MAX_PRODUCTS);

    sessionStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewed));
  }

  /**
   * Clears the recently viewed products.
   */
  static clearProducts() {
    sessionStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed product handles.
   * @returns {string[]} The list of handles.
   */
  static getProducts() {
    return JSON.parse(sessionStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
